import { reduce, append } from 'ramda'

export default function(p) {
  const builder = new ValidationBuilder('product')
  builder.shouldBeTruthy('ProductKey')
  builder.shouldBeTruthy('ProductNameInternal')
  builder.shouldNotBeUndefined('ProductNeedsToBeScheduled')
  builder.shouldNotBeUndefined('ProductQuantity')
  builder.shouldNotBeUndefined('BasePrice')
  builder.shouldNotBeUndefined('PriceType')
  builder.shouldNotBeUndefined('PriceOffset')
  const validator = builder.build()
  const errors = validator.validate(p)
  errors.forEach(console.error)
  return errors.length === 0
}

// todo: extract to reusable utility script
class Validator {
  constructor(validationTypes) {
    this.validationTypes = validationTypes
    this.modelName = validationTypes.modelName
  }
  validate(model) {
    const validationsErrors = []
    const undefinedErrors = reduce((agg, key) => {
      const thing = model[key]
      return thing === undefined ? append(`${this.modelName}.${key} is undefined`, agg) : agg
    }, [])
    const nullOrUndefinedErrors = reduce((agg, key) => {
      const thing = model[key]
      return thing === undefined || thing === null
        ? append(`${this.modelName}.${key} is null or undefined`, agg)
        : agg
    }, [])
    const truthyErrors = reduce((agg, key) => {
      const thing = model[key]
      return !thing ? append(`${this.modelName}.${key} is not truthy but ${thing}`, agg) : agg
    }, [])
    return [
      ...undefinedErrors(this.validationTypes.notUndefineds),
      ...nullOrUndefinedErrors(this.validationTypes.notNils),
      ...truthyErrors(this.validationTypes.truthys),
    ]
  }
}

class ValidationBuilder {
  constructor(modelName) {
    this.modelName = modelName
    this.truthys = []
    this.notUndefineds = []
    this.notNils = [] // not null or undefined
  }

  shouldBeTruthy(key) {
    this.truthys.push(key)
  }

  shouldNotBeUndefined(key) {
    this.notUndefineds.push(key)
  }

  shouldNotBeNullOrUndefined(key) {
    this.notNils.push(key)
  }

  build() {
    return new Validator(this)
  }
}
